export default __webpack_public_path__ + "static/VolodymyrKlykov-221dc70fb3cf05c74e835619318558e8.jpeg";